<template>
  <div class="home">
    <RegisWorld v-if="!this.$store.state.isLogin" />
  </div>
</template>

<script>
// @ is an alias to /src
import RegisWorld from "../components/Homepage/FormRegis.vue";

export default {
  name: "Home",
  components: {
    RegisWorld
  }
};
</script>

